import {createEntityAdapter} from '@reduxjs/toolkit';

/** @namespace Facilities.Adapters */

/**
 * CRUD adapter for handling facilities data within the store.  Entities are sorted by title by default.
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const facilitiesAdapter = createEntityAdapter({
    sortComparer: (a, b) =>
        a.title ? a.title.localeCompare(b.title) : a.name.localeCompare(b.name),
});

/**
 * Adapter for handling filtered facilities data within the store. Entities are sorted by title by default.
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter*
 */
export const filteredFacilitiesAdapter = createEntityAdapter({
    sortComparer: (a, b) => a.title.localeCompare(b.title),
});
